import { render } from "./Cta4.vue?vue&type=template&id=56f7bd44"
import script from "./Cta4.vue?vue&type=script&lang=js"
export * from "./Cta4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__